import "./index.css";

// @ts-ignore
const version: string = import.meta.env.VITE_VERSION ?? "unknown";
console.info("start", { version });

import { Game, GameApi, NewGame, getCommandValidation, init } from "./business";
import { dummyGame } from "./business/dummyGame";
import { envVariables, gameSerializer, neo4jConfig } from "./infra";
import { XRouter } from "./jsx/XRouter";
import { discreteGameBuilder } from "./utils";

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();

init();

export const {
  GameWithProviders,
  useGame,
  render,
  useCommandAction,
  useSessionUser,
  useLobbyGame,
  LobbyProvider,
  useLobby,
  useGameOpt,
  AllProviders,
  GameReplayProvider,
  useReplayContext,
} = discreteGameBuilder({
  gameApi: (game: Game, playerId: string) => GameApi(game, playerId),
  isValidCommand: getCommandValidation,
  copyGame: (game) => {
    const newGame = gameSerializer().copy(game);
    newGame.infoEvents = [];
    return newGame;
  },
  dummyGame: dummyGame(),
  newGame: NewGame.fromLobbyGame,
  syncAdapterProps: {
    gameName: "Spicy worms",
    neo4jConfig: envVariables.stateInMemory ? undefined : neo4jConfig,
  },
});

export type GameContext = ReturnType<typeof useGame>;

render({
  children: <XRouter />,
  elementId: "root",
});
